import { Component, effect, inject } from '@angular/core';
import { DividerModule } from '@openng/optimus-ui/divider';
import { TranslatePipe } from '@ngx-translate/core';
import { TableColumn } from '../../../../modules/shared/components/kit/table/table.types';
import { routeParams, translate } from '../../../../modules/shared/shared.global-service';
import { FilterBuilder } from '../../../../modules/content/helper/filter.builder';
import { DepartmentObject } from '@libs/types/src/mado/object-type/organization/department.object';
import { OrganizationSettingsDepartmentStore } from './organization-settings-department.store';
import {
    OrganizationSettingsDepartmentDialogComponent,
} from './dialog/organization-settings-department-dialog.component';
import { departmentFrag } from './organization-settings-department.query';
import { BaseDialogService } from '../../../kit/base-dialog/base-dialog-service';
import { TableComponent } from '../../../../modules/shared/components/kit/table/table.component';

@Component({
    selector: 'app-organization-settings-department',
    templateUrl: './organization-settings-department.component.html',
    providers: [OrganizationSettingsDepartmentStore],
    imports: [
        DividerModule,
        TranslatePipe,
        TableComponent,
    ],
})
export class OrganizationSettingsDepartmentComponent {
    protected readonly store = inject(OrganizationSettingsDepartmentStore);
    protected readonly dialogService = inject(BaseDialogService);

    protected readonly prefix = 'organization-settings.mado.department.';

    protected columns: TableColumn[] = [
        {
            name: 'name',
        },
        {
            name: 'code',
        },
        {
            name: 'description',
        },
    ];

    constructor() {
        effect(() => {
            this.loadDepartments();
        });
    }

    openDialog(department: DepartmentObject | null = null) {
        const header = `${this.prefix}title` + (department ? 'Detail' : 'Create');
        const dialog = this.dialogService.open(
            OrganizationSettingsDepartmentDialogComponent,
            {
                header: translate.instant(header),
                data: { department },
            },
        );

        dialog?.onClose.subscribe((it) => {
            if (it === true) {
                this.loadDepartments();
            }
        });
    }

    loadDepartments() {
        const organizationId = routeParams.organizationId();

        this.store.api.getDepartments(FilterBuilder.singlePage({ organizationId }), departmentFrag).then();
    }
}
